import React, { useState, useEffect } from 'react';
import { Col, CardBody, Input, Button, FormGroup } from 'reactstrap';
import { toast } from 'react-toastify';
import APIClient from '../../helpers/APIClient';
import Loader from '../../components/Loader';
import { connect } from 'react-redux';
import { baseUrl } from '../../constants/environment';
import { checkRole } from '../../helpers/Roles';
import moment from 'moment';
import Flatpickr from 'react-flatpickr';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import styled from 'styled-components';
import NumberFormat from 'react-number-format';
import TextUtils from '../../helpers/TextUtils';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

const BatchAdd = (props: any) => {
    const { product_name, product_id, variant_id, sku, indexProduct, closeModal, action, onlyView} = props
    const [loading, setLoading] = useState(false);
    const [batch, setBatch] = useState<any>([]);
    const type = action?.type

    useEffect(()=>{
        setBatch([{
            name: genBatchCode(),
            product_id: product_id,
            variant_id: variant_id,
            production_date: moment().startOf('day').valueOf(),
            expiration_date: '',
            quantity: 1,
        }])
    },[])

    const genBatchCode = ()=>{
        const codeName = product_name.substring(0, 1);
        const codeTime = `${moment().startOf('day').format('DDMMYYYY')}`
        const codeRandom = uuidv4().substring(0, 3)
        return `${codeName}-${codeTime}-${codeRandom}`.toLocaleUpperCase()
    }

    const validationFrom = () => {
        const check = batch?.reduce((prev:any, item:any)=>{
            if(!item?.name || !item?.quantity || !item?.production_date || !item?.expiration_date){
                prev = false
            }
            return prev
        }, true)
        if(!check){
            toast.warning('Nhập đầy đủ thông tin lô hàng!');
            return false
        }
        
        return true
    }
    
    const handleSubmit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/product-batch`;
        new Promise(resolve => {
            let data:any = [];
            batch?.map(async(item:any, index:number)=>{
                const id = await APIClient.POST(url, item);
                data.push({
                    ...id?.response,
                    quantity_import: item?.quantity
                });
                if(data?.length === batch?.length) resolve(data)
            })
            return data
        }).then((data:any)=>{
            setLoading(false)
            toast.success('Thêm lô cho sản phẩm thành công')
            closeModal()
            props.onUpdateBatch(data, product_id, variant_id, indexProduct)
        })
        
    }

    const handleBatchAdd = () => {
        const newDetailtiveUser = {
            name: genBatchCode(),
            product_id: product_id,
            variant_id: variant_id,
            production_date: moment().startOf('day').valueOf(),
            expiration_date: '',
            quantity: 1,
        };
        setBatch([...batch, newDetailtiveUser]);
    };

    const handleBatchUpdate = (batchDetail: any, index: number) => {
        let newDetailtiveUser = cloneDeep(batch);
        newDetailtiveUser[index] = batchDetail;
        setBatch(newDetailtiveUser);
    };

    const handleBatchRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(batch);
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser.push({
            name: genBatchCode(),
            product_id: product_id,
            variant_id: variant_id,
            production_date: moment().startOf('day').valueOf(),
            expiration_date: '',
            quantity: 1,
        })
        setBatch(newDetailtiveUser);
    };

    if(!checkRole(props?.user?.roles, ['batchAdd', 'batchEdit'], props?.user?.role)){
        return (
            <CardBody className='p-0' style={{width:460}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }

    console.log("BatchAdd", batch)

    return (
        <CardBody className='p-0' style={{width: 800}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                {
                    action?.type === 'addBatch' ? `Thêm lô cho sản phẩm #${sku || variant_id || sku}` :
                    action?.type === 'editBatch' ? `Chỉnh sửa lô cho sản phẩm #${sku || variant_id || sku}` :
                    action?.type === 'viewBatch' ? `Chi tiết sản phẩm #${sku || variant_id || sku}`
                    : "Thông báo"
                }
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-0">
                <PageContent className={onlyView ? 'only-view' : ''}>
                    <div className="table-responsive" style={{overflow: 'unset'}}>
                        <table className="mb-0 table-custom no-bg table table-input" >
                            <thead>
                                <tr>
                                    <th className='text-center' style={{ width: '25%' }}>Mã Lô</th>
                                    <th className='text-center' style={{ width: '18%' }}>Ngày sản xuất</th>
                                    <th className='text-center' style={{ width: '18%' }}>Hạn sử dụng</th>
                                    <th className='text-center' style={{ width: '20%' }}>Số lượng</th>
                                    {!onlyView &&<th style={{ width: '10%' }}></th>}
                                </tr>
                            </thead>
                            <tbody>
                            {
                                batch?.map((item:any, index:number) => (
                                    <BatchItem 
                                        detailIndex={index} 
                                        detail={batch}
                                        batch={item}
                                        onChangeData={(dataDetail: any) =>
                                            handleBatchUpdate(dataDetail, index)
                                        }
                                        type={type}
                                        onlyView={onlyView}
                                        handleRemoveData={() => handleBatchRemove(index)}
                                        handleAddData={() => handleBatchAdd()}
                                    />
                                ))
                            }
                            </tbody>
                        </table>
                        <div className='select-menu-add' style={{
                            border: 'none',
                            justifyContent: 'left'
                        }} onClick={handleBatchAdd}>
                            <i className="uil-plus mr-1"></i> Thêm mới
                        </div>
                    </div>
                </PageContent>
            </div>
            {action?.type !== 'view' &&
            <div className="modal-footer">
                <Button
                    onClick={()=>{
                        action?.type === 'addBatch' && handleSubmit() 
                    }}
                    className="ml-2" color="success" type="button"
                >{(action?.type === 'add' || action?.type === "addBatch") ? "Lưu": "Xác nhận"}</Button>
            </div>}
            {loading && <Loader />}
        </CardBody>

    )
}

const BatchItem = (props:any) => {
    const {detailIndex, detail, onChangeData, batch, type, onlyView, handleRemoveData, handleAddData} = props
    
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        onChangeData({
            ...batch,
            [name]: value
        })
    }

    return(
        <tr key={`batch-${detailIndex}`}>
            <td>
                <Input 
                    type="text" 
                    value={type === 'view' && !batch?.name ? '---': batch?.name}
                    disabled={onlyView} 
                    placeholder={(type=='view' && !batch?.name) ? "---" : "Mã lô"} 
                    onChange={(e: any) => handleChangeData({ target: { name: 'name', value: e.target.value } })}
                />
            </td>
            <td>
                <Flatpickr
                    value={[new Date(batch?.production_date)]}
                    onChange={(date: any) => {
                        const day = date[0] ? moment(date[0]) : undefined
                        handleChangeData({ target: { name: 'production_date', value: moment(day).startOf('day').valueOf() } })
                    }}
                    options={{
                        locale: Vietnamese,
                        allowInput: true,
                        dateFormat: "d/m/Y",
                        altInputClass: "date-range",
                    }}
                    className="form-control"
                    placeholder="dd/mm/yyyy"
                />
            </td>
            <td>
                <Flatpickr
                    value={[new Date(batch?.expiration_date)]}
                    onChange={(date: any) => {
                        const day = date[0] ? moment(date[0]) : undefined
                        handleChangeData({ target: { name: 'expiration_date', value: moment(day).startOf('day').valueOf() } })
                    }}
                    options={{
                        locale: Vietnamese,
                        allowInput: true,
                        dateFormat: "d/m/Y",
                        altInputClass: "date-range",
                        minDate: 'today'
                    }}
                    className="form-control"
                    placeholder="dd/mm/yyyy"
                />
            </td>
            <td>
                <NumberFormat 
                    onChange={(e: any) => handleChangeData({ target: { name: 'quantity', value: TextUtils.onlyNumber(e.target.value) } })}
                    name={'quantity'} type={'text'} className="form-control" 
                    value={type === 'view' && !batch?.quantity ? '---': batch?.quantity}
                    disabled={onlyView}
                    placeholder={(type=='view' && !batch?.quantity) ? "---" : "Nhập số lượng..."} thousandSeparator={true} 
                />
            </td>
            <td>
                <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
            </td>
        </tr>
    )
}

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`
const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
    }),
};

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(BatchAdd)